























import { defineComponent } from '@vue/composition-api';
import { BaseIcon, IconSize } from '../base-icon';

export default defineComponent({
  name: 'BaseBreadcrumbItem',
  components: { BaseIcon },
  props: {
    hideIcon: {
      type: Boolean,
      default: false,
    },
    dataExternal: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    clickable: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const handleClick = () => {
      if (!props.disabled && props.clickable) {
        emit('click');
      }
    };
    return { IconSize, handleClick };
  },
});
